import React from "react";
import founderImg from "../../images/founder3.jpg";

const FounderVisionCentered: React.FC = () => {
  return (
    <section className="founder-vision-centered">
      <div className="fv-container">

        {/* LEFT IMAGE */}
        <div className="fv-image">
          <img src={founderImg} alt="Founder" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="fv-content">

          <h1 className="fv-title">
            Building The Future Of Blockchain
          </h1>

          <div className="fv-quote">
            <p>
              “Innovation begins where possibilities <br />
              meet purpose.”
            </p>

            <span>
              — <strong>Mr. Avinash Sharma</strong>, Founder & CEO,{" "}
              <span className="brand">Comcodes Techwork</span>
            </span>
          </div>

          <p className="fv-text">
  Under the leadership of Mr. Avinash Sharma, Comcodes Techwork has evolved into a
  next-generation blockchain and crypto development company—helping businesses
  adopt decentralised technologies with confidence and clarity.
</p>

<p className="fv-text">
  His vision blends deep technical expertise with real-world business insight,
  guiding teams to build secure, scalable, and future-ready blockchain
  ecosystems that deliver long-term value.
</p>


          <div className="fv-stats">
            <div>
              <h2 className="orange">375+</h2>
              <span>HAPPY CLIENTS</span>
            </div>

            <div>
              <h2 className="cyan">1500+</h2>
              <span>PROJECTS COMPLETED</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FounderVisionCentered;
